import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LifelyProvider } from "./context/LifelyContext";
import AuthWrapper from "./components/auth/AuthWrapper";
import Layout from "./components/layout/Layout";
import Dashboard from "./pages/Dashboard";
import MapsOverview from "./pages/MapsOverview";
import MapDetail from "./pages/MapDetail";
import ContinuityOverview from "./pages/ContinuityOverview";
import ContinuitySetup from "./pages/ContinuitySetup";
import PrintExport from "./pages/PrintExport";
import WillStatus from "./pages/WillStatus";
import Contacts from "./pages/Contacts";
import ContactExport from "./pages/ContactExport";
import Sharing from "./pages/Sharing";
import Settings from "./pages/Settings";
import MemberstackInitializer from "./components/auth/MemberstackInitializer";

function App() {
  return (
    <LifelyProvider>
      <MemberstackInitializer />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout><AuthWrapper><Dashboard /></AuthWrapper></Layout>} />
          <Route path="/maps" element={<Layout><AuthWrapper><MapsOverview /></AuthWrapper></Layout>} />
          <Route path="/maps/:mapId" element={<Layout><AuthWrapper><MapDetail /></AuthWrapper></Layout>} />
          <Route path="/continuity" element={<Layout><AuthWrapper><ContinuityOverview /></AuthWrapper></Layout>} />
          <Route path="/continuity/setup" element={<Layout><AuthWrapper><ContinuitySetup /></AuthWrapper></Layout>} />
          <Route path="/print-export" element={<Layout><AuthWrapper><PrintExport /></AuthWrapper></Layout>} />
          <Route path="/will-status" element={<Layout><AuthWrapper><WillStatus /></AuthWrapper></Layout>} />
          <Route path="/contacts" element={<Layout><AuthWrapper><Contacts /></AuthWrapper></Layout>} />
          <Route path="/contacts/:contactId/export" element={<Layout><AuthWrapper><ContactExport /></AuthWrapper></Layout>} />
          <Route path="/sharing" element={<Layout><AuthWrapper><Sharing /></AuthWrapper></Layout>} />
          <Route path="/settings" element={<Layout><AuthWrapper><Settings /></AuthWrapper></Layout>} />
        </Routes>
      </BrowserRouter>
    </LifelyProvider>
  );
}

export default App;
